module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lFxKd"))).then(() => parcelRequire('3a9aZ'));